var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-container",
        {
          staticClass: "px-0",
          attrs: {
            fluid: "",
          },
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "6",
                    sm: "6",
                    md: "6",
                    lg: "3",
                    xl: "2",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "mb-2",
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            outlined: "",
                            elevation: "1",
                            block: "",
                            color: "info",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleSlug("lotto_thai")
                            },
                          },
                        },
                        [_vm._v("\n            หวยรัฐ\n          ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "6",
                    sm: "6",
                    md: "6",
                    lg: "3",
                    xl: "2",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "mb-2",
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            outlined: "",
                            elevation: "1",
                            block: "",
                            color: "yellow darken-2",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleSlug("soidown")
                            },
                          },
                        },
                        [_vm._v("\n            สอยดาวและยี่กี\n          ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "6",
                    sm: "6",
                    md: "6",
                    lg: "3",
                    xl: "2",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "mb-2",
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            outlined: "",
                            elevation: "1",
                            block: "",
                            color: "success",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleSlug("stock")
                            },
                          },
                        },
                        [_vm._v("\n            หวยหุ้น\n          ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                  },
                },
                [
                  _c("v-data-table", {
                    staticClass: "elevation-0",
                    attrs: {
                      "footer-props": _vm.footer,
                      headers: _vm.headers,
                      items: _vm.items,
                      loading: _vm.loading,
                      "multi-sort": false,
                      options: _vm.options,
                      "server-items-length": _vm.totalItems,
                      dense: "",
                      "item-key": "id",
                    },
                    on: {
                      "update:items": function ($event) {
                        _vm.items = $event
                      },
                      "update:options": function ($event) {
                        _vm.options = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.detail",
                        fn: function (_ref) {
                          var item = _ref.item
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "text-center",
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      outlined: "",
                                      small: "",
                                      color: "green darken-3",
                                      title: "ดูรายละเอียด",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.displayDialog(item)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                ดูโพย\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                item.game.status === "open" &&
                                (item.status == "created" ||
                                  item.status == "pending") &&
                                _vm.role == "user"
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-1",
                                        attrs: {
                                          outlined: "",
                                          small: "",
                                          color: "red darken-2",
                                          title: "ยกเลิกโพย",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.cancelTicket(item.id)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                ยกเลิก\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.game_name",
                        fn: function (_ref2) {
                          var item = _ref2.item
                          return [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "/lotto/" + item.game.id,
                                  target: "blank",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "text-danger",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item.game.master.name) +
                                        " " +
                                        _vm._s(item.game.readable_edition) +
                                        _vm._s(item.game.game_thai_date)
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.created_at",
                        fn: function (_ref3) {
                          var item = _ref3.item
                          return [
                            item.created_at
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "d-block",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm
                                          .$moment(item.created_at)
                                          .format("YYYY-MM-DD HH:mm:ss")
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "item.amount",
                        fn: function (_ref4) {
                          var item = _ref4.item
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  Intl.NumberFormat("th-TH", {
                                    style: "currency",
                                    currency: "THB",
                                  }).format(item.amount)
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "item.win_amount",
                        fn: function (_ref5) {
                          var item = _ref5.item
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  Intl.NumberFormat("th-TH", {
                                    style: "currency",
                                    currency: "THB",
                                  }).format(
                                    item.win_amount > 0 ? item.win_amount : 0
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "item.status",
                        fn: function (_ref6) {
                          var item = _ref6.item
                          return [
                            item.status === "pending"
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2 text-lg",
                                    attrs: {
                                      label: "",
                                      small: "",
                                      color: "warning",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              กำลังประมวลผล\n            "
                                    ),
                                  ]
                                )
                              : item.status === "created"
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2 text-lg",
                                    attrs: {
                                      label: "",
                                      small: "",
                                      color: "light-blue",
                                      "text-color": "white",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              รอยืนยันผล\n            "
                                    ),
                                  ]
                                )
                              : item.status === "cancel_by_game"
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2 text-lg text-white",
                                    attrs: {
                                      label: "",
                                      small: "",
                                      color: "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              ยกเลิกเกมส์\n            "
                                    ),
                                  ]
                                )
                              : item.status === "cancel_by_user"
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2 text-lg text-white",
                                    attrs: {
                                      label: "",
                                      small: "",
                                      color: "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              ยกเลิกโพย\n            "
                                    ),
                                  ]
                                )
                              : item.status === "committed"
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2 text-lg",
                                    attrs: {
                                      label: "",
                                      small: "",
                                      color: "warning",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              กำลังคำนวน\n            "
                                    ),
                                  ]
                                )
                              : item.status === "complete"
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2 text-lg text-white",
                                    attrs: {
                                      label: "",
                                      small: "",
                                      color: "success",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              จบเกมส์\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "item.id",
                        fn: function (_ref7) {
                          var item = _ref7.item
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(`#${item.lotto_game_id}${item.id}`)
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectedItem
        ? _c(
            "v-dialog",
            {
              attrs: {
                fullscreen: "",
                scrollable: "",
              },
              model: {
                value: _vm.selectedItem,
                callback: function ($$v) {
                  _vm.selectedItem = $$v
                },
                expression: "selectedItem",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: {
                        color: "red",
                        height: "55",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        {
                          staticClass: "pa-0",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-body-1 text-uppercase text-light",
                            },
                            [_vm._v(_vm._s(_vm.gameName))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.closeDialog()
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    {
                      staticClass: "pt-3 pb-3 px-3",
                    },
                    [
                      _c("ticket-number", {
                        attrs: {
                          transaction: _vm.ticketNumberItem,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.preload
        ? _c(
            "v-dialog",
            {
              attrs: {
                persistent: "",
                width: "500",
                "max-width": "100vw",
              },
              model: {
                value: _vm.preload,
                callback: function ($$v) {
                  _vm.preload = $$v
                },
                expression: "preload",
              },
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "pa-md-10 mx-lg-auto",
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "text-center",
                    },
                    [
                      _c("v-progress-circular", {
                        attrs: {
                          size: 100,
                          width: 10,
                          indeterminate: "",
                          color: "red",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("b-modal", {
        attrs: {
          id: "bv-modal-result",
          size: "xl",
          "hide-footer": "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }